import { Injectable } from '@angular/core';
import { HashMap, TranslocoService } from '@ngneat/transloco';
import { LocalizationStart, LocalizationTranspilerService } from '@platform-frontend/transloco';
import {
  TokenizeResult,
  TranslationMarkupRendererFactory,
  TranslationMarkupTranspiler,
  TranslationMarkupTranspilerContext,
  TranspileResult
} from 'ngx-transloco-markup';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../marketplace-transloco-scope';
import { SubscriptionIntervalParams } from '../product/model/subscription-interval-params';

export class SubscriptionIntervalStart extends LocalizationStart {
  constructor(override readonly paramsKey: string) {
    super(paramsKey);
  }
}

@Injectable()
export class SubscriptionIntervalTranspiler implements TranslationMarkupTranspiler {
  constructor(
    private localizationTranspilerService: LocalizationTranspilerService,
    private readonly rendererFactory: TranslationMarkupRendererFactory,
    private translocoService: TranslocoService
  ) {}

  tokenize(translation: string, offset: number): TokenizeResult | undefined {
    return this.localizationTranspilerService.tokenize(
      translation,
      offset,
      'subscriptionInterval',
      (paramsKey: string) => new SubscriptionIntervalStart(paramsKey)
    );
  }

  transpile(start: number, context: TranslationMarkupTranspilerContext): TranspileResult | undefined {
    const createText = (translationParameters: HashMap, paramsKey: string): string => {
      const params = translationParameters[paramsKey] as SubscriptionIntervalParams;
      return this.translocoService.translate('product.subscriptionInterval.' + params.interval + '.' + params.displayMode, {}, MARKETPLACE_TRANSLOCO_SCOPE);
    };

    return this.localizationTranspilerService.transpile(
      start,
      context,
      (translationParameters: HashMap, paramsKey: string) => createText(translationParameters, paramsKey),
      this.rendererFactory,
      (token: unknown) => (token instanceof SubscriptionIntervalStart ? token.paramsKey : undefined)
    );
  }
}
